/** @jsxImportSource react */

import { useShare } from '@common/helpers/share';
import InlineGwizzyAccordian from '@react/gwizzy/components/InlineGwizzyAccordian';
import { leadSourceMap } from '@sly/core/constants/uuidActions';
import { useRouter } from 'next/router';

import { ToolHero } from './Styles';
import { ToolDetails } from '../types';

export default function MatchWithAdvisorTool({
  heading,
  description,
  shortDescription,
}: ToolDetails) {
  const { query } = useRouter();
  const { state, city } = query;
  const { share } = useShare();
  return (
    <div className='space-y-8'>
      <ToolHero
        heading={heading}
        subheading={description}
        onShare={() => {
          share({
            title: heading,
            text: shortDescription || description || '',
            url: window.location.href,
          });
        }}
      />
      <div className='mx-auto rounded-lg border border-slate-lighter-95 md:max-w-2xl'>
        <InlineGwizzyAccordian
          community={null}
          eventProps={{
            location: `${heading} tool`,
            state,
            city,
            isOpenByDefault: true,
            cta: 'Inline Gwizzy',
          }}
          mode={{
            entry: 'toolsPage',
            leadSource: leadSourceMap.MatchWithAdvisorLS,
          }}
          showLocationStep={true}
          submitText='Connect me with an advisor'
          skipHomebaseRedirect
        />
      </div>
    </div>
  );
}
